<template>
  <div
    class="button-group-container tw:border tw:border-blue-700 tw:rounded-sm tw:text-blue-700"
    :class="version === '2' ? 'box-size-36' : 'box-size-44'"
  >
    <button
      v-for="item in items"
      :key="item.value"
      :value="item.value"
      class="tw:px-2 tw:outline-0 tw:focus:outline-0 tw:text-sm"
      :class="
        value === item.value
          ? `${version === '2' ? 'tw:px-7 tw:bg-blue-700 tw:text-white' : 'tw:bg-blue-700 tw:text-white'}`
          : `${version === '2' ? 'tw:px-7' : ''}`
      "
      @click="emit('onClick', $event.target.value)"
      :data-testid="buttonTestIdPrefix ? `${buttonTestIdPrefix}-${item.value}` : null"
    >
      {{ $t(item.label) }}
    </button>
  </div>
</template>

<script setup>
const emit = defineEmits(['onClick'])
defineProps({
  items: {
    type: Array,
    required: true,
    default() {
      return []
    },
  },
  value: {
    type: [String, Number],
    required: true,
    default: '',
  },
  version: {
    type: String,
    required: false,
    default: '1',
  },
  buttonTestIdPrefix: {
    type: String,
    default: '',
  },
})
</script>
<style scoped>
.button-group-container {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  border-radius: 8px;
}
.button-group-container > button:not(:last-child) {
  border-right: 1px solid var(--tw-color-blue-700);
}
.button-group-container button:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.button-group-container button:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
</style>
